import { BaseError } from "../base/BaseError";

export class TooManyRequestsError extends BaseError {
  message =
    "قمت بإدخال رمز خاطئ 3 مرات يرجى الانتظار دقيقتين قبل المحاولة مجددا";
}
